// ConsoleSyncBadge stub - Console sync functionality discontinued
import { Badge } from '@/components/ui/badge';

interface ConsoleSyncBadgeProps {
  syncedAt?: string | null;
  customerId?: string | null;
  compact?: boolean;
}

export function ConsoleSyncBadge({ syncedAt, customerId, compact }: ConsoleSyncBadgeProps) {
  if (!customerId) {
    return compact ? null : (
      <Badge variant="outline" className="text-muted-foreground">
        Não sincronizado
      </Badge>
    );
  }
  
  return (
    <Badge variant="default" className="bg-green-100 text-green-800">
      Sincronizado
    </Badge>
  );
}

export default ConsoleSyncBadge;
